//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../no/SelectBody.js";
import "../no/ScCollector.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AddedPartName",1,0],[1,"ArcRadius",0,"Expression",0],[0,"BlankPosition",1,0],[1,"BlankProfile",0,"Section",0],[0,"BlankType",1,0],[0,"BurringDirection",1,0],[1,"BurringInsertDelete",0,"Assemblies.SelectComponentList",0],[0,"BurringInsertPart",1,"TaggedObject",0],[0,"BurringPunchType",1,0],[0,"CircularOrNonCircular",1,0],[0,"DesignOption",1,0],[1,"EndValue",0,"Expression",0],[0,"ParentPart",1,0],[0,"ParentPartName",1,0],[0,"PlateClearanceFirst",1,0],[0,"PlateClearanceSecond",1,0],[0,"PlateClearanceThird",1,0],[1,"PunchHeadHeight",0,"Expression",0],[1,"PunchOrDieToEdit",0,"SelectBody",0],[0,"RenameComponent",1,0],[1,"SelectFaces",0,"ScCollector",0],[1,"StartValue",0,"Expression",0],[0,"UsePlateClearanceFirst",1,0],[0,"UsePlateClearanceSecond",1,0],[0,"UsePlateClearanceThird",1,0]],[[["parentTag","origin"],"CreateNewComponent",{R_:{instance:"TaggedObject"}},2,0],[[],"RevolveSketchedCurve",{},0,0],[[],"DeletePunchOrDieComponent",{},0,0],[[],"CreateOffsetDatumPlaneForBurringDie",{},0,0],[[],"AddInsertComponent",{},0,0],[["partTag","isSuppress"],"SuppressOrUnsuppressFeatures",{},2,0]],[]];
SPLM.Tooling.BurringInsertBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.BurringInsertBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.BurringInsertBuilder.BurringDirections = Object.freeze({
    "BurringUpwards" : "BurringUpwards", "BurringDownwards" : "BurringDownwards"});

SPLM.Tooling.BurringInsertBuilder.DesignOptions = Object.freeze({
    "BurringPunch" : "BurringPunch", "BurringDie" : "BurringDie", "BurringAll" : "BurringAll"});

SPLM.Tooling.BurringInsertBuilder.CircularOrNonCircularType = Object.freeze({
    "Circular" : "Circular", "NonCircular" : "NonCircular"});

SPLM.Tooling.BurringInsertBuilder.ParentTypes = Object.freeze({
    "Control" : "Control", "DieBase" : "DieBase", "SubDie" : "SubDie", "Die" : "Die"});

SPLM.Tooling.BurringInsertBuilder.BurringPunchTypes = Object.freeze({
    "First" : "First", "Second" : "Second", "Third" : "Third"});

SPLM.Tooling.BurringInsertBuilder.BlankTypes = Object.freeze({
    "Standard" : "Standard", "UserDefined" : "UserDefined", "Edit" : "Edit", "Delete" : "Delete"});

SPLM.Tooling.BurringInsertBuilder.BlankPositions = Object.freeze({
    "PunchPlate" : "PunchPlate", "StripperPlate" : "StripperPlate", "DiePlate" : "DiePlate", "BottomBackingPlate" : "BottomBackingPlate", "TopPunchPlate" : "TopPunchPlate", "BottomPunchPlate" : "BottomPunchPlate"});

export default SPLM;